import { Injectable } from '@angular/core';
import { RemoteConfigService } from 'src/app/lib/remote-config/remote-config.service';
import { PrivacyPolicyAggregate } from './privacy-policy-aggregate';
import { PrivacyPolicyUrl } from './privacy-policy-url';
import { PrivacyPolicyVersion } from './privacy-policy-version';

@Injectable({ providedIn: 'root' })
export class PrivacyPolicyRepository {
  constructor(private readonly remoteConfig: RemoteConfigService) {}

  get(): PrivacyPolicyAggregate {
    const version = new PrivacyPolicyVersion(
      this.remoteConfig.getNumber('privacy_policy_version'),
    );
    const url = new PrivacyPolicyUrl(
      this.remoteConfig.getString('privacy_url'),
    );

    return new PrivacyPolicyAggregate({
      version,
      url,
    });
  }
}
